import { Card, CardContent, Stack } from '@mui/material'
import React from 'react'
import { SkeletonText } from 'utoniq-ui'

import { OrganismFrame } from '@/core/architecture'

export const StorePurchaseHistorySkeleton = () => (
  <OrganismFrame>
    <Card sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: 5, '&:last-child': { pb: 5 } }}>
        <Stack direction="row" spacing={2}>
          <Stack width="30%">
            <SkeletonText variant="h3" />
          </Stack>
          <Stack width="calc(70% - 8px)">
            <SkeletonText variant="h3" />
          </Stack>
        </Stack>
        <SkeletonText variant="h3" width="30%" sx={{ pt: 3 }} />
        <Stack spacing={1} sx={{ pt: 3 }}>
          <Stack flex={1} direction="row" spacing={2}>
            <Stack flex={3}>
              <SkeletonText variant="small" />
            </Stack>
            <Stack flex={1}>
              <SkeletonText variant="small" />
            </Stack>
          </Stack>
          <Stack flex={1} direction="row" spacing={2}>
            <Stack flex={3}>
              <SkeletonText variant="small" />
            </Stack>
            <Stack flex={1}>
              <SkeletonText variant="small" />
            </Stack>
          </Stack>
          <Stack flex={1} direction="row" spacing={2}>
            <Stack flex={3}>
              <SkeletonText variant="small" />
            </Stack>
            <Stack flex={1}>
              <SkeletonText variant="small" />
            </Stack>
          </Stack>
        </Stack>
        <Stack spacing={1} sx={{ pt: 3 }}>
          <SkeletonText variant="h3" width="30%" />
          <SkeletonText variant="h3" width="30%" />
        </Stack>
      </CardContent>
    </Card>
  </OrganismFrame>
)
